import { customFields, setCustomFields, form, appointmentChannelId, patientSelected } from '../../utils/variables';
import { filterFieldsForPatientType } from '../../utils/qualificationVisibility';
import { loadAllQuestionsPage } from '../../views/pages/allQuestions';
import { navigate } from '../events/movePages';
import { SCREEN } from '../../utils/constants';

export function shouldShowAllQuestions() {
    // When widget uses consult_request_fields (inline or one-per-page), do not also show the all-questions screen
    // so users are not asked the same or another set of questions twice (individually then all together).
    if (!appointmentChannelId && Array.isArray(form?.consult_request_fields) && form.consult_request_fields.length > 0) {
        return false;
    }

    const questionnaire = customFields?.length
        ? customFields
        : (appointmentChannelId
            ? form?.appointment_channel?.qualification_form?.custom_fields
            : form?.consult_request_fields || form?.form?.custom_fields);

    // Fields gated to another patient type don't count — a questionnaire whose
    // every field targets e.g. new patients is skipped for returning patients.
    if (filterFieldsForPatientType(questionnaire ?? [], patientSelected).length > 0) {
        return true;
    }

    return false;
}

export function loadAllQuestionsFlow() {
    // Prefer consult_request_fields when no appointment channel so we show one consistent set of questions
    const questionnaire = customFields?.length
        ? customFields
        : (appointmentChannelId
            ? form?.appointment_channel?.qualification_form?.custom_fields
            : form?.consult_request_fields || form?.form?.custom_fields);

    const visibleQuestionnaire = filterFieldsForPatientType(questionnaire ?? [], patientSelected);
    if (visibleQuestionnaire.length === 0) {
        return false;
    }

    setCustomFields(visibleQuestionnaire);

    navigate(SCREEN.ALL_QUESTIONS);

    loadAllQuestionsPage();

    return true;
}

export function shouldTriggerAllQuestionsAfterValidation() {
    return shouldShowAllQuestions();
}
